import React from 'react';
import './generalErrorPage.css';
import { useDispatch } from 'react-redux';

const GeneralErrorPage = () => {

  const dispatch = useDispatch();

  const goBack = () => {
    dispatch({ type: 'SET_RESERVATION_ABLE' });
    window.location.replace('/');
  };

  return (
    <div className="error-page">
      <div className="container">
        <div className="error-icon">✖</div>

        <h1>No se pudo completar la operación</h1>

        <p>Lamentamos informarle que ha ocurrido un error al procesar su solicitud.</p>

        <p>El sistema no ha podido completar la operación en este momento. Por favor, intente nuevamente más tarde.</p>

        <a href="#" className="btn" onClick={goBack}>Regresar</a>

        <div className="footer">
          <p>La Campiña Glamping Club © 2025 | Todos los derechos reservados</p>
        </div>
      </div>
    </div>
  );
};

export default GeneralErrorPage;